import { Dispatch } from 'redux';
import { StoreState } from '../store-interfaces';
import CrudActionContainer from './CrudActionContainer';
import FBPostController from '../controllers/FBPostController';
import commonHandler from '../errorHandlers/common-handler';
import fbPostHandler from '../errorHandlers/fb-post-handler';
import { getActionHookBuilder } from './action-hook-builder';

class FBPostCRUDActions extends CrudActionContainer {
  retrievedRecommendedAction: string;
  retirievedByIdAction: string;

  constructor() {
    super('FBPost');
    this.retrievedRecommendedAction = this.makeActionKey(
      'RETRIEVED_RECOMMENDED_ACTION',
    );
    this.retirievedByIdAction = this.makeActionKey('RETRIEVED_BY_ID_ACTION');
  }

  retrieveAll(pageId: number, skipBusy?: boolean) {
    return async (dispatch: Dispatch<StoreState>) => {
      if (!skipBusy) {
        dispatch(this.busy(this.retrieveAllAction));
      }
      try {
        const response = await FBPostController.getAll(pageId);
        dispatch(this.retrievedAll(response));
        return response;
      } catch (e) {
        return commonHandler(dispatch)(e);
      }
    };
  }

  retrieveRecommended(pageId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      try {
        const response = await FBPostController.getRecommended(pageId);
        dispatch({
          type: this.retrievedRecommendedAction,
          recommended: response,
        });
        return response;
      } catch (e) {
        return commonHandler(dispatch)(e);
      }
    };
  }

  retrieveById(pageId: number, postId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.retrieveAction));
      try {
        const response = await FBPostController.getById(pageId, postId);
        dispatch({
          type: this.retirievedByIdAction,
          entity: response,
        });
        return response;
      } catch (e) {
        return fbPostHandler(dispatch)(e);
      }
    };
  }
}

const fbPostCRUDActions = new FBPostCRUDActions();
export default fbPostCRUDActions;

export const useFbPostCRUDActions = getActionHookBuilder(fbPostCRUDActions, [
  'retrieveAll',
  'retrieveRecommended',
  'retrieveById',
]);
